import * as ActionTypes from '../actions/PageStateActions';

const initialPageState = {
  inTraffic: false,
  isAsync: false,
  scrollToFirstError: false,
  isAppOffline: false,
  isContentOffline: false,
  isRequestTimeout: false,
  isContentAreaBackgroundShown: true,
};

export function pageState (state = initialPageState, action) {
  switch (action.type) {
    case ActionTypes.ENABLE_PAGE_STATE_ASYNC:
      return {
        ...state,
        isAsync: true,
      };

    case ActionTypes.DISABLE_ACTION_ITEMS:
      return {
        ...state,
        inTraffic: true,
      };

    case ActionTypes.ENABLE_ACTION_ITEMS:
      return {
        ...state,
        inTraffic: false,
      };

    case ActionTypes.DISABLE_PAGE_STATE_ASYNC:
      return {
        ...state,
        isAsync: false,
      };

    case ActionTypes.MARK_PAGE_NOT_FOUND:
      return {
        ...state,
        isPageNotFound: true,
      };

    case ActionTypes.MARK_PAGE_FOUND:
      return {
        ...state,
        isPageNotFound: false,
      };

    case ActionTypes.SCROLL_TO_FIRST_ERROR:
      return {
        ...state,
        scrollToFirstError: true,
      };

    case ActionTypes.UNMARK_SCROLL_TO_FIRST_ERROR_FLAG:
      return {
        ...state,
        scrollToFirstError: false,
      };

    case ActionTypes.MARK_APP_OFFLINE: {
      return {
        ...state,
        isAppOffline: true,
      };
    }

    case ActionTypes.MARK_APP_ONLINE: {
      return {
        ...state,
        isAppOffline: false,
      };
    }

    case ActionTypes.MARK_CONTENT_ONLINE: {
      return {
        ...state,
        isContentOffline: false,
      };
    }

    case ActionTypes.MARK_CONTENT_OFFLINE: {
      return {
        ...state,
        isContentOffline: true,
      };
    }

    case ActionTypes.MARK_REQUEST_TIMEOUT: {
      return {
        ...state,
        isRequestTimeout: true,
      };
    }

    case ActionTypes.MARK_REQUEST_SUCCESSFUL: {
      return {
        ...state,
        isRequestTimeout: false,
      };
    }

    case ActionTypes.TOGGLE_CONTENT_AREA_BACKGROUND:
      return {
        ...state,
        isContentAreaBackgroundShown: action.status,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/PageStateReducers.js